
import { Component, Mixins } from "vue-property-decorator";
import { IIdPropertyEditable, instanceOfIIdPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class IdPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IIdPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IIdPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isIdEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIIdPropertyEditable(s) && s.id().isEditable(), false);
  }

  get id(): number {
    return this.readPropertyOrDefault(s => s.id().getValue(), undefined);
  }

  set id(value: number) {
    this.writePropertyWhenValid(s => s.id().setValue(value));
  }
}
